import { gql } from "@apollo/client";

export const FETCH_ODOO_SO = gql`
  query FETCH_ODOO_SO($warehouseId: Int!) {
    odooSaleOrders(instance: "AB", useType: "ANITA", warehouseId: $warehouseId)
  }
`;
